import { H1, VStack } from '@montel/montelpro-shared-components-v2';
import { FunctionComponent, ReactNode } from 'react';

const Page: FunctionComponent<{ heading?: string; children: ReactNode }> = ({
	heading,
	children,
}) => (
	<VStack fullWidth gap="xl">
		{heading && <H1>{heading}</H1>}
		{children}
	</VStack>
);

export default Page;
